/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-unused-vars */
import { useEffect, useState, ReactNode, SetStateAction } from 'react'

import { Col } from 'base/src/components/Basic/Col/col';
import { Checkbox } from "base/src/components/Checkbox/index"

import { ObjectControl, SetArrayObject, ValueCheckKey } from 'domain/utils/ReactUtils'


import { FilterRequest, Paged, PagedListRequest } from 'domain/types/global/pagedListRequest';
import { Input } from 'base/src/components/Input';
import StateMensage from 'base/src/view/states/state';
import { View } from 'base/src/components/Basic/View/view';

import * as S from './styles';
import { useTheme } from 'base/src/utils/context/themeContext';
import { Filter, FilterObject } from 'base/src/components/Filter';
import { Either, NestedKeys } from '../../utils/propsUtil';
import { Pagination } from '../Pagination';
import { IPagedListResponse } from 'domain/types/global/pagedListResponse';
//import { RootBaseState } from '../../store/baseStore';
import { mapLoading } from '../../utils/componentUtil';
import NoData from '../NoData';
import { toArray } from '../../utils/stringUtil';

interface Props0<T, L> {

  /**
   * Lista de páginação com os elementos a serem exibidos.
   */
  originalState: IPagedListResponse<T> | undefined;

  /**
   * Função executa ao páginar.
   */
  handlePagination: (request: PagedListRequest<T>) => void;

  /**
   * Função deve retornar o elemento a ser exibido.
   * @param object - O objeto do tipo T a ser renderizado.
   * @param key - Id do array.
   * @param value - Se o objeto está selecionado.
   * @returns - Um ReactNode.
   */
  element: (object: T, key: number, value?: boolean | undefined) => ReactNode;

  /**
  * Lambda de verificação para ativação do checkbox
  * @param object - O objeto do tipo T a ser renderizado.
  * @param key - Id do array.
  * @param value - Se o objeto está selecionado.
  * @returns - Um ReactNode.
  */
  elementCheck?: (object: T, key: number, value?: boolean | undefined) => boolean;


  /**
  * Elemento que será o header da lista.
  */
  elementHeader?: ReactNode;

  /**
   * Quantidade de itens a serem exibidos por página.
   */
  take: number;

  /**
   * Define qual propriedade de T será usada como tipo de busca.
   */
  searchType: NestedKeys<T>[];

  /**
  * Estado opcional para mostrar se os dados estão carregando EX EXEMPLO_GET.
  */
  loadingState?: string;


  /**
   * Configurações opcionais manipulação de dados.
   */
  controlRequest?: {

    /**
     * Define se será usado dentro de um formulário.
     */
    form?: boolean;

    /**
     * Executa ao selecionar todos os itens de uma lista.
     * @param value - Indica o estado da seleção.
     * @param list - Lista de objetos do tipo T.
     */
    handleSelectAll?: (value: boolean, list: T[] | undefined) => void;

    /**
     * Executa quando algum item for selecionado.
     * @param value - Indica o estado da seleção.
     * @param object - Objeto do tipo T a ser marcado.
     */
    handleChecked?: (value: boolean, object: T) => void;

    /**
     * Controle de request.
     */
    control: ObjectControl<L>;

    /**
     * Objeto de stado controlado por um Control. Caso não indormado será usado o do Control
     */
    state?: L;

    /**
     * Propriedade do tipo L que representa uma lista de itens.
     */
    propertyList: keyof L;

    /**
     * Propriedade do tipo T que representa o identificador de um item na lista EX: UsuarioID.
     */
    propertyID: keyof T;


  };

  /**
     * Propriedade para recarregar a lista de itens.
     */
  reloadState?: boolean;

  /**
    * Configurações opcionais de request de dados.
    */
  paged?: {

    /**
     * Controle de paginação.
     */
    pagedSetRequest: React.Dispatch<React.SetStateAction<PagedListRequest<T>>>

    /**
    * Estado de paginação.
    */
    pagedRequest: PagedListRequest<T>
  },

  action?: React.ReactElement;

  /**
   * Elemento opcional que será renderizado ao lado do filtro.
   */
  filterSideElement?: React.ReactElement;

  /**
   * Configuração opcional para a barra de pesquisa.
   */

  searchBar?: {

    /**
     * Título da barra de pesquisa.
     */
    title?: string;

    /**
     * Placeholder para a barra de pesquisa.
     */
    placeHolder: string;

    /**
     * Função opcional para atualizar o estado da barra de pesquisa.
     */
    setSearchBar?: React.Dispatch<SetStateAction<string | undefined>>;
  };

  /**
   * Configuração opcional de filtros adicionais.
   */
  filter?: {

    /**
     * Título da seção de filtros.
     */
    title: string;

    /**
     * Descrição da seção de filtros.
     */
    description: string;

    /**
     * Lista de filtros aplicáveis.
     */
    filters: FilterObject[];

    /**
     * Estado opcional para mostrar se os filtros estão carregando EX EXEMPLO_GET.
     */
    loadingState?: string;
  };

  /**
   * Elemento opcional que será renderizado ao lado do componente Pagination.
   */
  paginationSideElement?: React.ReactElement;
}

interface Props1<T> {
}
interface Props2 {

}

export type PagedProps<T, K extends keyof T, L, J extends keyof L> = Props0<T, L> & Either<Props1<T>, Props2>;


type ControlState<L> = {
  [key: string]: L;
};

export function PagedElement<T, K extends keyof T, L, J extends keyof L>(props: PagedProps<T, K, L, J>) {
  const { theme } = useTheme();
  // const _userData = _UserData;
  // const { i18n, t } = useTranslation();

  const [itemPaged, setItemPaged] = useState<Paged<T>>({ skip: 0, take: props.take } as Paged<T>)

  //const [request, setRequest] = useState<PagedListRequest<T>>({} as PagedListRequest<T>)

  const [searchBar, setSearchBar] = useState<string>()

  const controlState: ControlState<L> | undefined = (props.controlRequest?.state ? props.controlRequest?.state : props.controlRequest?.control.state) as ControlState<L>
  const propertyListKey = props.controlRequest && props.controlRequest.propertyList as string;
  const controlList = propertyListKey && controlState[propertyListKey] as T[];

  const [filters, setFilters] = useState(props.filter?.filters);
  const [filterAsync, setfilterAsync] = useState<FilterRequest[]>([]);


  useEffect(() => {
    if (filterAsync.length == 0 && filterAsync.length != props.filter?.filters.length) { return } //Quando todos os filtros forem aplicados então será aplicado no request
    if (props.paged?.pagedRequest == null) { return }
    props.paged?.pagedSetRequest((prevState) => ({
      ...prevState,
      skip: 0,
      take: props.take,
      filter: filterAsync.every(e => e.Values != undefined && e.Values.length > 0) ? filterAsync : undefined
    }));

    setItemPaged({ skip: 0, take: props.take })
  }, [filterAsync])


  //Reset State: Resets the paginated data state when the original state is reset.
  useEffect(() => {
    if (props.originalState?.Reset == true) {
      props.paged?.pagedSetRequest((prevState) => ({
        ...prevState,
        skip: 0,
        take: props.take
      }));
    }
    //setItemPaged({ skip: 0, take: props.take })

    //  setItemPaged((prevState) => ({
    //   ...prevState,
    //   skip: 0,
    //   take: props.take,
    //   Array: prevState.Array
    // }));
  }, [props.originalState?.Reset]);

  // useEffect(() => {
  //   setfilterAsync([])

  //   props.paged?.pagedSetRequest((prevState) => ({
  //     ...prevState,
  //     skip: 0,
  //     take: props.take,
  //     filter: []
  //   }));

  //   setItemPaged({ skip: 0, take: props.take })
  // }, [props.paged?.pagedRequest.filter])

  useEffect(() => {
    if (props.filter?.filters == filters) { return }
    const updatedFilters = props.filter?.filters.map((f, i) => {
      const current = f.onChange;

      // Cria um novo objeto para forçar uma nova referência
      return {
        ...f,
        onChange: (value: string[] | Date[] | undefined) => {

          handleFilter(toArray<string>(value as string[]), f, i);

          if (current) {
            if (typeof value === "string" || value === undefined) {
              if (typeof current === "function") {
                (current as (val: string | undefined) => void)(value);
              }
            } else if (Array.isArray(value)) {
              if (value.every((item) => item instanceof Date)) {
                if (typeof current === "function") {
                  (current as (val: Date[] | undefined) => void)(value);
                }
              } else {
                // Se for um array de string
                if (typeof current === "function") {
                  (current as (val: string[] | undefined) => void)(value);
                }
              }
            }
          }

        }
      };
    });

    // Atualiza o estado com os filtros modificados
    setFilters(updatedFilters);
  }, [props.filter?.filters]);


  function handlePagination(value: PagedListRequest<T>, notForce = false) {
    if (value.skip == undefined || value.take == undefined) { return }
    value.filter = props.paged?.pagedRequest.filter //preserva o atual
    value.selectAll = props.paged?.pagedRequest.selectAll
    props.paged?.pagedSetRequest(value)
    notForce == false && props.handlePagination(value)
  }

  useEffect(() => {
    if (props.paged?.pagedRequest.selectAll == true) {
      handleSelectAll(true)
    }
  }, [itemPaged])


  function handleSelectAll(value: boolean) {
    if (!props.controlRequest) { return }
    if (props.paged?.pagedSetRequest == null) { return }
    props.paged?.pagedSetRequest(prevState => ({
      ...prevState,
      selectAll: value,
    }));

    props.controlRequest.control.setObject(props.controlRequest.propertyList as string, value ? itemPaged.Array?.map((f, i) => props.elementCheck && !props.elementCheck(f, i) ? f : false) : [])
    props.controlRequest.handleSelectAll && props.controlRequest.handleSelectAll(value, value ? itemPaged.Array?.filter((f, i) => props.elementCheck && !props.elementCheck(f, i) ? f : false) : [])

  }


  // useEffect(() => { //Search barr desativa o selectAll
  //   if(searchBar != null){
  //    // handleSelectAll(false)
  //   }
  // }, [searchBar])

  useEffect(() => { //handleCheckAll
    if (props.paged?.pagedRequest == undefined || props.paged?.pagedRequest.selectAll == undefined) { return }
    handlePagination(props.paged?.pagedRequest, true)
  }, [props.paged?.pagedRequest.selectAll])





  function handleFilter(value: string[] | Date[] | undefined, filterObject: FilterObject, index: number) {
    const filterRequest = {
      Values: value,
      Id: index,
      Name: filterObject.name
    } as FilterRequest;

    setfilterAsync(prevFilterAsync => {
      const existingFilterIndex = prevFilterAsync.findIndex(filter => filter.Id === index);

      const updatedFilters = existingFilterIndex !== -1
        ? prevFilterAsync.map((filter, indexMap) => indexMap === existingFilterIndex ? filterRequest : filter)
        : [...prevFilterAsync, filterRequest];

      return updatedFilters;
    });
  }

  function handleCheck(value: boolean, objeto: T) {
    if (!props.controlRequest || !controlState) { return }
    if (props.paged?.pagedRequest.selectAll == undefined || props.paged?.pagedRequest.selectAll == false) {


      controlList ? props.controlRequest.control.setObject(props.controlRequest.propertyList as string, SetArrayObject(controlList, objeto, value)) :
        props.controlRequest.control.setObject(props.controlRequest.propertyList as string, [objeto]) //first

      controlList && props.controlRequest.handleChecked && props.controlRequest.handleChecked(value, objeto)
    } else {
      handleSelectAll(false)
    }
  }


  function handleSearchBar(value: string | number | undefined) {
    setSearchBar(value == undefined ? "" : String(value))
    if (props.searchBar && props.searchBar.setSearchBar) {

      props.searchBar.setSearchBar(value == undefined ? "" : String(value))
    }
  }

  useEffect(() => { //handleFilter
    if (itemPaged == null || props.paged?.pagedRequest == undefined) { return }
    handlePagination(props.paged?.pagedRequest)
  }, [props.paged?.pagedRequest.filter])

  useEffect(() => {
    if (props.reloadState && (!itemPaged.Array || itemPaged.Array.length == 0)) {
      setItemPaged({ skip: 0, take: 0 })
    }
  }, []);

  function HasNoData() {
    return !itemPaged.Array || itemPaged.Array.length === 0;
  }

  return (
    <View>
      <View>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 10 }}>

          {props.searchBar &&
            <Input form={false} title={props.searchBar.title} borderColor={theme.colors.border_grey} placeholder={props.searchBar.placeHolder} value={searchBar} setValue={handleSearchBar} />
          }
          {
            props.action &&
            <>{props.action}</>
          }

          <div style={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 10 }}>
            {props.filter && filters &&
              <Filter filtros={filters} title={props.filter.title} description={props.filter.description}></Filter>
            }
            {
              props.filterSideElement &&
              <>{props.filterSideElement}</>
            }
          </div>

          {props.filter && props.filter.loadingState &&
            <StateMensage stateLoadingNames={[props.filter.loadingState]} />
          }
        </div>
      </View>

      <Col style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

        {props.controlRequest != undefined ? (
          <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox disabled={itemPaged.Array?.length == 0} defaultChecked={props.paged?.pagedRequest?.selectAll} value={props.paged?.pagedRequest?.selectAll} setValue={function handleChkAll(v) { handleSelectAll(Boolean(v)) }} />
              <span>Selecionar todos</span>
            </div>
            {props.elementHeader &&
              props.elementHeader
            }
            {HasNoData() ? (
              <NoData />
            ) :

              (mapLoading(itemPaged.Array != null && itemPaged.Array.length !== 0,
                itemPaged.Array && itemPaged.Array.map((u, k) => {
                  const chkState = props.controlRequest && controlState && ValueCheckKey(controlList as Array<T>, u[props.controlRequest.propertyID], props.controlRequest.propertyID);
                  return (
                    <S.Container>
                      <Checkbox disabled={(props.elementCheck && props.elementCheck(u, k, chkState)) || props.paged?.pagedRequest?.selectAll} key={props.controlRequest && u[props.controlRequest.propertyID] as number} defaultChecked={chkState} form={props.controlRequest && props.controlRequest.form} name={props.controlRequest && u[props.controlRequest.propertyID] as string} value={chkState} setValue={function handleChkCheck(v) { handleCheck(Boolean(v), u) }} >
                        {props.element(u, k, chkState)}
                      </Checkbox>

                    </S.Container>
                  )
                }), props.take, S.SkeletonCss
              ))}
          </>
        ) : (
          <>
            {props.elementHeader && props.elementHeader}
            {HasNoData() ? (
              <NoData />
            ) :

              (
                mapLoading(
                  itemPaged.Array != null && itemPaged.Array.length !== 0,
                  //@ts-expect-error: TypeScript cannot infer the type of itemPaged.Array
                  itemPaged?.Array.map((u, k) => (
                    <S.Container key={k}>
                      <S.UserContainer>
                        {props.element(u, k)}
                      </S.UserContainer>
                    </S.Container>
                  )),
                  props.take,
                  S.SkeletonCss
                )
              )}
          </>
        )}

        {props.loadingState &&
          <StateMensage stateLoadingNames={[props.loadingState]} stateErrorNames={[props.loadingState]} />
        }
      </Col>

      <Pagination<T, K> filters={filterAsync} searchType={props.searchType} setSearchBar={setSearchBar} search={searchBar} paginationState={itemPaged} originalState={props.originalState} setPaginationState={setItemPaged} onChange={handlePagination} takeValue={props.take} />
    </View>
  )
}